<ng-template #child>
  <ng-content></ng-content>
</ng-template>
<ng-container *ngIf="historyType === 'history' && mode === HstFvtModeEnum.reference">
  <a
    href="#"
    id="search-flight-history-select-modal-item-link-1"
    class="c-history-list__link"
    (click)="this.clickItemInReferenceMode($event)"
  >
    <span class="u-visually-hidden" [innerHTML]="'reader.history.selected' | staticMsg"></span>
    <ng-container *ngTemplateOutlet="child"></ng-container>
  </a>
</ng-container>
<ng-container *ngIf="historyType === 'history' && mode === HstFvtModeEnum.delete">
  <div class="c-history-list__link" role="button" tabindex="0">
    <ng-container *ngTemplateOutlet="child"></ng-container>
  </div>
</ng-container>
<ng-container *ngIf="historyType === 'favorite' && mode === HstFvtModeEnum.reference">
  <div
    class="c-history-list__link"
    role="button"
    tabindex="0"
    (throttleClick$)="this.clickItemInReferenceMode($event)"
    aswThrottleClick
  >
    <span class="u-visually-hidden" [innerHTML]="'reader.favorite.selected' | staticMsg"></span>
    <ng-container *ngTemplateOutlet="child"></ng-container>
  </div>
</ng-container>
<ng-container *ngIf="historyType === 'favorite' && mode === HstFvtModeEnum.delete">
  <div class="c-history-list__link" role="button" tabindex="0">
    <ng-container *ngTemplateOutlet="child"></ng-container>
  </div>
</ng-container>
